import React from 'react';
import { FormattedMessage } from 'react-intl';


const CardComparisonEligibilitySection = {
    sectionId: 'eligibility',
    sectionLabel: (
        <FormattedMessage
            id="edb.cc.side-by-side-v2.eligibility"
            defaultMessage="Eligibility"
        />
    ),
    items: [
        {
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.personal-income"
                    defaultMessage="Personal income"
                />
            ),
            cardPropertyKey: 'personalIncome',
            isExpandable: false,
        },
        {
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.household-income"
                    defaultMessage="Household income"
                />
            ),
            cardPropertyKey: 'householdIncome',
            isExpandable: false,
        },
        {
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.minimum-credit-score"
                    defaultMessage="Minimum credit score"
                />
            ),
            cardPropertyKey: 'minimumCreditScore',
            isExpandable: false,
        },
    ],
};

export default CardComparisonEligibilitySection;
